export const companiesColors = ['#8ed2cc', '#8eb6d2', '#dab7db', '#e5c1c6', '#fbcba4'];
